import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SectionWrapper = styled.div`
  display: flex;
  gap: 6px;
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  max-width: 100%;
  height: 5px;
  border-radius: 27px;
  background-color: ${({ theme }) => theme.colors.dataViz.progressBarBgColor};
`;

export const ProgressBarInner = styled.div`
  border-radius: 27px;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.dataViz.progressBarColor};
  transition: width 0.5s ease-in-out;
  width: ${({ percentageProgress }) => percentageProgress}%;
  max-width: 100%;
`;

export const ArrowSection = styled.div`
  margin-right: 10px;
`;
